import React from 'react'
import { useExportTyrehubPoint, useGetTyrehubPoints } from '../../api/point'
import { PointPanelScreen } from '../shared/PointPanelScreen'
import { PointsRemaining } from './PointsRemaining'
import { TYREHUB } from '../shared/companies'

export const TyrehubPoints = () => {
  const columns = [
    { id: 'companyAccountId', label: 'Company Id' },
    { id: 'companyName', label: 'Company Name' },
    { id: 'point', label: 'Total Points' },
    {
      id: 'remainingPoints',
      label: 'Points Remaining',
      view: PointsRemaining,
    },
    { id: 'salesId', label: 'Sales Id' },
  ]

  return (
    <PointPanelScreen
      title='Tyrehub Trip Point'
      htgCompany={TYREHUB}
      useExportApi={useExportTyrehubPoint}
      useGetPoints={useGetTyrehubPoints}
      columns={columns}
      linkBase='tyrehub-trip-summary'
    />
  )
}
